import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-add-day-dialog',
    templateUrl: './add-day-dialog.component.html',
    styleUrls: ['./add-day-dialog.component.css'],
    standalone: false
})
export class AddDayDialogComponent {
  newDay: number;
  defaultPct: number = 0;
  errorMsg: string = '';

  existingDays: number[] = [];

  constructor(public dialogRef: MatDialogRef<AddDayDialogComponent>) {}

  submit() {
    if (this.newDay == null || isNaN(this.newDay)) {
      this.errorMsg = 'Please enter a valid day.';
      return;
    }

    if (this.existingDays.includes(this.newDay)) {
      this.errorMsg = 'This day already exists.';
      return;
    }

    this.dialogRef.close({
      day: this.newDay,
      defaultPct: this.defaultPct ?? 0
    });
  }
}
